var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1502 1.94995H5.8502C3.7052 1.94995 1.9502 3.70495 1.9502 5.84995V33.15C1.9502 35.2969 3.7052 37.0499 5.8502 37.0499H19.5002V23.4H15.6002V18.5737H19.5002V14.5762C19.5002 10.3564 21.8636 7.3924 26.8439 7.3924L30.3597 7.3963V12.4761H28.0256C26.0873 12.4761 25.3502 13.9308 25.3502 15.2802V18.5757H30.3578L29.2502 23.4H25.3502V37.0499H33.1502C35.2952 37.0499 37.0502 35.2969 37.0502 33.15V5.84995C37.0502 3.70495 35.2952 1.94995 33.1502 1.94995Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.fe84a30e74a18acb7adc8425bcb37672.svg";
export { ForwardRef as ReactComponent };